"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableStreamCountries = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
var AvailableStreamCountries;
(function (AvailableStreamCountries) {
    AvailableStreamCountries["FR"] = "fr";
    AvailableStreamCountries["CA"] = "ca";
})(AvailableStreamCountries = exports.AvailableStreamCountries || (exports.AvailableStreamCountries = {}));
const countriesByStreamLocations = {
    "ca": ["AG", "BS", "BB", "BZ", "CA", "CR", "CU", "DM", "DO", "SV", "GD", "GT", "HT", "HN", "JM", "MX", "NI", "PA", "KN", "LC", "VC", "TT", "US"]
};
class CountrySelector extends EventTarget {
    constructor() {
        super(...arguments);
        this.findBestCountry = () => {
            console.debug('findBestCountry()');
            this.dispatchEvent(new Event("searching"));
            fetch("https://ipapi.co/country").then((response) => {
                return response.text();
            }).then((userCountryCode) => {
                console.debug(userCountryCode);
                for (const streamCountry in countriesByStreamLocations) {
                    const countries = countriesByStreamLocations[streamCountry];
                    if (countries.indexOf(userCountryCode) != -1) {
                        this.selectCountry(streamCountry);
                        return;
                    }
                }
                this.selectCountry(AvailableStreamCountries.FR);
            });
        };
        this.selectCountry = (countryCode) => {
            if (!Object.values(AvailableStreamCountries).includes(countryCode)) {
                throw new Error(`Unknown country ${countryCode}`);
            }
            if (this._selectedStreamCountryCode === countryCode) {
                this.dispatchEvent(new CustomEvent("changed", { detail: this._selectedStreamCountryCode }));
                return;
            }
            this._selectedStreamCountryCode = countryCode;
            js_cookie_1.default.set("stream-country", this._selectedStreamCountryCode);
            this.dispatchEvent(new CustomEvent("changed", { detail: this._selectedStreamCountryCode }));
        };
        this.getCountry = () => {
            return this._selectedStreamCountryCode;
        };
    }
    load() {
        const cookieStreamCountry = js_cookie_1.default.get("stream-country");
        if (cookieStreamCountry) {
            this.selectCountry(cookieStreamCountry);
        }
        else {
            this.findBestCountry();
        }
    }
}
exports.default = CountrySelector;
